import { Button, Card, Text } from 'evergreen-ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function SwitchSignInUpComponent({ login, switchCard }) {
  const navigate = useNavigate();
  return (
    <Card
      className="switch-card"
      background='white'
      padding={16}
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      borderTop="1px solid #e6e8f0"
    >
      {login ? (
        <>
          <Text className="switch-text">Não possui conta?</Text>
          <Button 
            className="switch-button"
            onClick={() => navigate('/planos')}
            appearance="minimal"
            intent="success"
          >
            Registre-se
          </Button>
        </>
      ) : (
        <>
          <Text className="switch-text">Já possui conta?</Text>
          <Button 
            className="switch-button"
            onClick={switchCard}
            appearance="minimal"
            intent="success"
          >
            Logar-se
          </Button>
        </>
      )}
      <style jsx='true'>
        {`
          .switch-card {
            width: 100%;
            transition: all 0.3s ease;
            border-top-width: 1px;
            border-top-style: solid;
            border-top-color: #e6e8f0;
            background-color: #f9f9fb;
          }
          
          .switch-text {
            font-size: 14px;
            color: #66788A;
            font-weight: 500;
          }
          
          .switch-button {
            color: #27E2E7 !important;
            font-weight: 600;
            transition: all 0.2s ease;
            padding: 8px 16px;
            border-radius: 4px;
          }
          
          .switch-button:hover {
            text-decoration: underline;
            background-color: rgba(39, 226, 231, 0.1) !important;
            transform: translateY(-1px);
          }
          
          .switch-button:active {
            transform: translateY(0);
          }
          
          @media (max-width: 480px) {
            .switch-card {
              padding: 16px 24px;
              flex-direction: column;
              gap: 12px;
            }
          }
        `}
      </style>
    </Card>
  );
}

export default SwitchSignInUpComponent;
